<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh">KATIE COLLINS NEEDS TO LISTEN TO HER MAMA'S WISDOM:</p><p class="nl1">1. Love makes us do amazing, wonderful things…and really stupid things too.</p><p class="nl">2. A little restraint is fine…as long as you don't overdo it.</p><p class="nl">3. The most important thing you can do in life is to be your best you.</p><p class="nl">4. Don't waste time on a man unless his kiss makes you forget your name!</p><p class="nl3">5. I'd rather be brave enough to do something worthy of wild gossip than be so afraid of others’ disapproval that I do nothing at all.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SomeGirlsDo_pref-1.vue?7a9cda10